import {GameStateEnums} from '../../../../../shared/GameEnums'
import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameCityImprovementProgressTrackerView} from './UIGameCityImprovementProgressTrackerView'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGamePlayerInformationView} from '../ui_game_players/UIGamePlayerInformationView'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {TranslationObject} from '@colonist/i18n'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {CityImprovementTypes, MechanicCityImprovementsState, PlayerColor} from '@colonist/game-states'
import {MechanicValidatorCityImprovements} from '@colonist/game-mechanic-validators'

export class UIGamePlayerInformationCityImprovementProgressTrackerView extends SectionView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly cityImprovementProgressTrackerViews: UIGameCityImprovementProgressTrackerView[]
    private readonly playerInformation: UIGamePlayerInformationView
    private readonly cityImprovementsState: MechanicCityImprovementsState
    private readonly cityImprovementsValidator: MechanicValidatorCityImprovements

    constructor(uiGameManager: UIGameManager, cityImprovementsState: MechanicCityImprovementsState, playerColor: PlayerColor, x: number, y: number, w: number, h: number, container: PIXI.Container) {
        const removePadding = true
        super(x, y, w, h, container, removePadding)
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.cityImprovementsState = cityImprovementsState
        this.cityImprovementsValidator = new MechanicValidatorCityImprovements(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.cityImprovementsState)
        const playerInformation = this.uiGameManager.playersController.getPlayerInformationViewWithColor(playerColor)
        if(playerInformation == undefined) return
        this.playerInformation = playerInformation

        this.cityImprovementProgressTrackerViews = []
        this.initCityImprovementProgressTrackerViews()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CityImprovementStateUpdated: this.updateCityProgressTracker(); break
            default: break
        }
    }

    private initCityImprovementProgressTrackerViews() {
        const squareWidth = this.width / 3
        this.cityImprovementProgressTrackerViews.push(new UIGameCityImprovementProgressTrackerView(0, 0, squareWidth, this, CityImprovementTypes.Trade))
        this.cityImprovementProgressTrackerViews.push(new UIGameCityImprovementProgressTrackerView(squareWidth, 0, squareWidth, this, CityImprovementTypes.Politics))
        this.cityImprovementProgressTrackerViews.push(new UIGameCityImprovementProgressTrackerView(squareWidth * 2, 0, squareWidth, this, CityImprovementTypes.Science))
        this.updateCityProgressTracker()
    }

    private updateCityProgressTracker() {
        for(const cityImprovementProgressTrackerView of this.cityImprovementProgressTrackerViews) {
            const cityImprovementState = this.cityImprovementsValidator.getPlayerCityImprovementsStateForType(this.playerInformation.playerState.color, cityImprovementProgressTrackerView.cityImprovementType)
            if(cityImprovementState == undefined) continue

            cityImprovementState.hasMetropolis ? cityImprovementProgressTrackerView.showMetropolisIcon() : cityImprovementProgressTrackerView.hideMetropolisIcon()
            const previousCityLevel = cityImprovementProgressTrackerView.currentCityImprovementLevel
            const currentCityLevel = cityImprovementState.level

            if(previousCityLevel == currentCityLevel) continue
            cityImprovementProgressTrackerView.updateProgressTracker(cityImprovementState.level)
        }
    }

    private sendNotification(playerColor: PlayerColor) {
        const text: TranslationObject = {key: 'strings:game.gameState.gameLogs.cityImprovement'}

        this.uiGameManager.eventController.sendEvent({title: text, sprite: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.notification_city_improvement), playerColor: playerColor}, GameStateEnums.UIGameEventEnums.ShowNotification)
    }

    destroy() {
        super.destroy()

        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
